module.exports = __webpack_public_path__ + "img/四川天府新区红苹果幼儿园.03437b8f.jpg";